var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChangeVertical = function SvgChangeVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.804 16.387c0 .528-.443.97-.987.97H8.693a4.84 4.84 0 0 1-4.833-4.833V7.468H2.447a.88.88 0 0 1-.783-.46.926.926 0 0 1-.102-.425c0-.17.034-.323.136-.476l2.4-3.745a.87.87 0 0 1 .75-.408c.305 0 .577.153.748.408l2.4 3.745c.187.289.187.63.034.919a.883.883 0 0 1-.783.459h-1.43v5.039A2.884 2.884 0 0 0 8.693 15.4h1.123c.545 0 .988.443.988.987zm6.81-3.812a.932.932 0 0 1-.035.919l-2.4 3.744a.92.92 0 0 1-.767.409.891.891 0 0 1-.748-.41l-2.4-3.743a.912.912 0 0 1-.035-.903.883.883 0 0 1 .784-.46h1.447V7.096a2.884 2.884 0 0 0-2.877-2.876H9.46a.989.989 0 0 1 0-1.975h1.123a4.842 4.842 0 0 1 4.834 4.834v5.038h1.413c.324 0 .63.17.783.46z",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgChangeVertical;